import React from "react";

export function TopicTile({ topic, active, onClick }) {
  const fallbackGradient = `linear-gradient(135deg, ${topic.tint.join(", ")})`;
  return (
    <button
      className={`topic-tile block w-full text-left ${active ? "active" : ""}`}
      data-testid={`topic-tile-${topic.slug}`}
      onClick={() => onClick(topic.slug)}
    >
      <div className="topic-thumb relative" style={{ background: fallbackGradient }}>
        {topic.image && (
          <img
            src={topic.image}
            alt={topic.title}
            className="absolute inset-0 w-full h-full object-cover"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        )}
        {active && (
          <div className="absolute top-2 right-2 bg-primary text-white text-[9px] font-bold uppercase tracking-widest px-1.5 py-0.5 rounded">
            Attivo
          </div>
        )}
      </div>
      <div className="w-full px-3 py-2.5 bg-white">
        <div className="text-[13px] font-semibold text-ink text-center leading-tight">{topic.title}</div>
      </div>
    </button>
  );
}
